import { useState } from "react";
import { Dropdown, Form } from "react-bootstrap";
import "./style.css";

interface IProps {
  label: string;
  options: string[];
  value: string[];
  onChange: (selectedValues: string[]) => void;
  className?: string;
  isInvalid?: boolean;
  disabled?: boolean;
}

const DropdownInside = ({ label, options, value, onChange, className = "", isInvalid = false, disabled = false }: IProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleItemClick = (option: string) => {
    const currentValues = value || [];
    if (currentValues.includes(option)) {
      onChange(currentValues.filter((v) => v !== option));
    } else {
      onChange([...currentValues, option]);
    }
  };

  return (
    <Dropdown
      className={disabled ? "readonly" : ""}
      show={dropdownOpen}
      onToggle={(isOpen) => !disabled && setDropdownOpen(isOpen)}
      autoClose="outside"
      style={{ position: "static" }}
    >
      <Dropdown.Toggle
        disabled={disabled}
        className={`w-100 text-start dropdown-toggle-ellipsis ${isInvalid ? "border-danger" : ""} ${className}`}
        style={{
          backgroundColor: "white",
          color: "black",
          borderColor: dropdownOpen ? "#80cda4" : "#dee2e6",
          outline: 0,
          boxShadow: dropdownOpen ? "0 0 0 0.25rem rgba(0, 154, 73, .25)" : "none",
        }}
      >
        {value?.length > 0 ? value.join(", ") : `Select ${label}...`}
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="dropdown-inside-menu"
        renderOnMount
        flip
        popperConfig={{
          strategy: "fixed",
          modifiers: [
            {
              name: "flip",
              options: {
                boundary: "viewport",
                rootBoundary: "viewport",
                padding: 16,
                fallbackPlacements: ["top-start", "bottom-start"],
              },
            },
            {
              name: "preventOverflow",
              options: {
                boundary: "viewport",
                rootBoundary: "viewport",
                altAxis: true,
                padding: 16,
              },
            },
            {
              name: "computeStyles",
              options: {
                gpuAcceleration: false,
              },
            },
            {
              name: "sameWidth",
              enabled: true,
              phase: "beforeWrite",
              requires: ["computeStyles"],
              fn: ({ state }) => {
                state.styles.popper.width = `${state.rects.reference.width}px`;
              },
              effect: ({ state }) => {
                const reference = state.elements.reference as HTMLElement;
                if (reference && reference.offsetWidth) {
                  state.elements.popper.style.width = `${reference.offsetWidth}px`;
                }
              },
            },
          ],
        }}
      >
        {options.map((option) => (
          <Dropdown.Item
            key={option}
            as="div"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleItemClick(option);
            }}
          >
            <Form.Check
              type="checkbox"
              id={`option-${option}`}
              label={option}
              checked={value?.includes(option) || false}
              readOnly
            />
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DropdownInside;
